import { getOptionalFiles } from "services/sandbox-api/transforms";
import { RootState } from "store/reduxStore";
import { createSelector } from "@reduxjs/toolkit";
import { SourceFileView } from "@sandbox/code-editor";
import { getFilePath } from "./sandboxSlice";

export const selectActiveSandbox = (state: RootState) => state.activeSandbox.metadata;

export const activeFileSelector = createSelector(
  (state: RootState) => state.activeSandbox.editor.openFiles,
  (state: RootState) => state.activeSandbox.sourceFiles,
  (state: RootState) => state.activeSandbox.optionalFiles,
  (openFiles, sourceFiles, optionalFiles) => {
    const activeFile: SourceFileView | undefined = openFiles.find((item) => item.active);
    const file = [...sourceFiles, ...getOptionalFiles(optionalFiles)].find((item) => getFilePath(item) === (activeFile ? getFilePath(activeFile) : undefined));

    return {
      filePath: activeFile ? getFilePath(activeFile) : undefined,
      activeFile,
      content: file?.content,
    };
  });

export const sandboxFilesSelector = createSelector(
  (state: RootState) => state.activeSandbox.changedFiles,
  (state: RootState) => state.activeSandbox.sourceFiles,
  (state: RootState) => state.activeSandbox.optionalFiles,
  (state: RootState) => state.activeSandbox.metadata?.userId,
  (state: RootState) => state.auth.user?.id,
  (changedFiles, sourceFiles, optionalFiles) => {
    let files = getOptionalFiles(optionalFiles);

    for (let i = 0; i < sourceFiles.length; i++) {
      if (!sourceFiles[i].deleted) {
        const changed = changedFiles.find((changedFile) => getFilePath(changedFile) === getFilePath(sourceFiles[i]));
        if (changed) {
          files.push(changed);
        } else {
          files.push(sourceFiles[i])
        }
      }
    }
    // const defaultLoaderOptions: EditorFileLoaderOptions = {
    //   replace: /(?:START|END)\s*([A-Z0-9_-]+)/,
    // };

    // if (sandboxOwnerId !== userId) {
    //   //file.content = AnnotatonCommentParser.removeAnnotationLocations(file.content, defaultLoaderOptions)
    //   files = files.map((file) => {
    //     return {
    //       ...file,
    //       content: AnnotatonCommentParser.removeAnnotationLocations(file.content, defaultLoaderOptions)
    //     }
    //   })
    // }

    return files;
  });

export const filesDirtySelector = createSelector(
  (state: RootState) => state.activeSandbox.changedFiles,
  (files) => {
    return files.length !== 0;
  });


export const sandboxPublicFilesSelector = createSelector(
  (state: RootState) => state.activeSandbox.changedFiles,
  (state: RootState) => state.activeSandbox.sourceFiles,
  (changedFiles, sourceFiles) => {
    const files = [];

    for (let i = 0; i < sourceFiles.length; i++) {
      if (!sourceFiles[i].deleted && getFilePath(sourceFiles[i]).startsWith("/public")) {
        const changed = changedFiles.find((changedFile) => getFilePath(changedFile) === getFilePath(sourceFiles[i]));
        if (changed) {
          files.push(changed);
        } else {
          files.push(sourceFiles[i])
        }
      }
    }

    return files;
  });

export const readmePath = "/readme.md";
export const walkthroughPath = "/walkthrough.md";

export const sandboxReadmeSelector = createSelector(
  (state: RootState) => state.activeSandbox.sourceFiles,
  (sourceFiles) => {
    return sourceFiles.find((item) => getFilePath(item)?.toLowerCase() === readmePath);
  });

export const sandboxWalkthroughSelector = createSelector(
  (state: RootState) => state.activeSandbox.sourceFiles,
  (sourceFiles) => {
    return sourceFiles.find((item) => getFilePath(item)?.toLowerCase() === walkthroughPath);
  });

